import { render, staticRenderFns } from "./ProgressTip.vue?vue&type=template&id=40e12fa6&scoped=true"
import script from "./ProgressTip.vue?vue&type=script&lang=js"
export * from "./ProgressTip.vue?vue&type=script&lang=js"
import style0 from "./ProgressTip.vue?vue&type=style&index=0&id=40e12fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e12fa6",
  null
  
)

export default component.exports